import { createStore } from 'vuex'

// Create a new store instance.
export default createStore({
  state() {
    return {
      startrouter:null,
      isLoading: false,
      isDeclaration:JSON.parse(sessionStorage.getItem("isDeclaration")),
      clientId: JSON.parse(sessionStorage.getItem("clientId")),
      user: JSON.parse(sessionStorage.getItem("user")),
      flowcount: null,
      platform: null,
      token: JSON.parse(sessionStorage.getItem("token")),
      refreshToken: JSON.parse(sessionStorage.getItem("refreshToken")),
      sessionCode: JSON.parse(sessionStorage.getItem("sessionCode")),

      VendorCode4: JSON.parse(sessionStorage.getItem("VendorCode4")),


    }
  },
  actions: {
    setStartRouter(context, payload) {
      context.commit('Set_StartRouter', payload);
    },
    setLoading(context, payload) {
      context.commit('Set_Loading', payload);
    },
    setClientId(context, payload) {
      context.commit('Set_ClientId', payload);
    },
    setUser(context, payload) {
      context.commit('Set_User', payload);
    },
    setToken(context, payload) {
      context.commit('Set_User', payload);
    },
    setRefreshToken(context, payload) {
      context.commit('Set_User', payload);
    },
    setSessionCode(context, payload) {
      context.commit('Set_User', payload);
    },
    setFlowCount(context, payload) {
      context.commit('Set_FlowCount', payload);
    },
    setLanguage(context, payload) {
      context.commit('Set_Language', payload);
    },
    setIsActive(context, payload) {
      context.commit('Set_IsActive', payload);
    },
    setDeclaration(context, payload) {
      context.commit('Set_Declaration', payload);
    },
    setPlafotrm(context, payload) {
      context.commit('Set_Plafotrm', payload);
    },
    setVendorCode4(context, payload) {
      context.commit('Set_VendorCode4', payload);
    },
  },
  mutations: {
    Set_StartRouter(state, payload) {
      state.startrouter = payload;
     },


    Set_Loading(state, payload) {
      state.isLoading = payload;
     },
    Set_ClientId(state, payload) {
      state.clientId = payload;
      sessionStorage.setItem("clientId",  JSON.stringify(payload));
    },
    Set_User(state, payload) {
      //state.user = payload;
      sessionStorage.setItem("user",  JSON.stringify(payload));
    },
    Set_Token(state, payload) {
      state.token = payload;
      sessionStorage.setItem("token",  JSON.stringify(payload));
    },
    Set_RefreshToken(state, payload) {
      state.refreshToken = payload;
      sessionStorage.setItem("refreshToken",  JSON.stringify(payload));
    },
    Set_SessionCode(state, payload) {
      state.sessionCode = payload;
      sessionStorage.setItem("sessionCode",  JSON.stringify(payload));
    },
    Set_FlowCount(state, payload) {
      state.flowcount = payload;
    },
    Set_Language(state, payload) {
      state.user.Culture = payload;
    },
    Set_IsActive(state, payload) {
      state.user.IsActive = payload;
    },

    Set_Declaration(state, payload) {
      state.isDeclaration = payload;
      sessionStorage.setItem("isDeclaration",  JSON.stringify(payload));
    },
    Set_Plafotrm(state, payload) {
      state.platform = payload;
    },
    Set_VendorCode4(state, payload) {
      sessionStorage.setItem("VendorCode4",  JSON.stringify(payload));
    },
  },
  getters:{
     getVendorCode4() {
      //return state.refreshToken;
      return JSON.parse(sessionStorage.getItem("VendorCode4"));
    },
    getStartRouter(state) {
      return state.startrouter;
    },
    getIsLoading(state) {
      return state.isLoading;
    },
    getClientId(state) {
      console.log(state);
      return JSON.parse(sessionStorage.getItem("clientId"));
    },
    getUser() {
      //return state.user;
      return JSON.parse(sessionStorage.getItem("user"))
    },
    getToken() {
      //return state.token;
      return JSON.parse(sessionStorage.getItem("token"));
    },
    getRefreshToken() {
      //return state.refreshToken;
      return JSON.parse(sessionStorage.getItem("refreshToken"));
    },
    getSessionCode() {
      //return state.sessionCode;
      return JSON.parse(sessionStorage.getItem("sessionCode"));
    },
    getFlowCount(state) {
      return state.flowcount;
    },
    getDeclaration() {
      //return state.sessionCode;
      return JSON.parse(sessionStorage.getItem("isDeclaration"));
    },
    getPlatform(state) {
      return state.platform;
    },
  }
})


/* import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
  },
  actions: {
    setLoading(context, payload) {
      context.commit('Set_Loading', payload);
    }
  },
  mutations: {
    Set_Loading(state, payload) {
      state.isLoading = payload;
    }
  },

})
 */

/* import { createStore } from 'vuex'
export default createStore({
  state: {
    store: 'Vuex'
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
}) */